import api from './api';
import { FeatureCode } from '../common/enums/common.enum';

export interface KindergartenFeatureDto {
  id: string;
  code: FeatureCode;
  name: string;
  enabled: boolean;
}

/**
 * Returns a bare array rather than the usual { results } envelope, matching the other
 * routes on the feature controller, which mobile already consumes.
 */
export const getKindergartenFeatures = async (kindergartenId: string): Promise<KindergartenFeatureDto[]> => {
  const response = await api.get(`/feature/kindergarten/${kindergartenId}`);
  return response.data;
};
